import { render, staticRenderFns } from "./sipregister.vue?vue&type=template&id=2d2baf4a&scoped=true"
import script from "./sipregister.vue?vue&type=script&lang=js"
export * from "./sipregister.vue?vue&type=script&lang=js"
import style0 from "./sipregister.vue?vue&type=style&index=0&id=2d2baf4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2baf4a",
  null
  
)

export default component.exports